import { faCloud, faCode, faDatabase } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useRef } from "react";
import { FaLaptop } from "react-icons/fa";
import { ObserverContext } from "../../Contexts/ObserverContext";

function Services() {
  const ref = useRef();
  const { activeSection, setActiveSection } = useContext(ObserverContext);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setActiveSection("services");
        console.log("this is updated section", activeSection);
      }
    });
    if (ref && ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      observer.disconnect();
    };
  }, [ref]);

  return (
    <section className="services-section" id="services" ref={ref}>
      <div className="container">
        {/* Heading */}
        {/* <h1 className="wow fadeInDown" data-wow-delay="300ms">
          Our Exclusive Services (ERP Services)

        </h1> */}
        <h1
          className="wow fadeInDown"
          data-wow-delay="300ms"
          style={{
            fontWeight: "600", // make bold again
            textAlign: "center", // center align
          }}
        >
          Our Exclusive Services (ERP Services)
        </h1>

        <p className="wow fadeInDown" data-wow-delay="300ms">
          At Access Infotech Pvt. Ltd., we provide end-to-end IT and enterprise
          resource planning (ERP) solutions designed to help businesses operate
          smarter, faster, and more securely. With decades of experience in
          serving enterprises, government organizations, and SMEs, we specialize
          in building customized applications, streamlining complex processes,
          and ensuring robust database administration. Our services are tailored
          to meet the unique needs of industries such as pharmaceuticals,
          manufacturing, and defense — empowering organizations to improve
          efficiency, cut costs, and achieve digital transformation.
        </p>
        <h2 className="wow fadeInDown" data-wow-delay="300ms">
          Enterprise Resource Planning (ERP) Solutions
        </h2>
        <p className="wow fadeInDown" data-wow-delay="300ms">
          Our flagship ERP platform, AccessONE, offers a comprehensive suite of
          tools for finance, HR, inventory, sales, and operations management.
          Whether deployed on desktop or mobile, our ERP system integrates
          seamlessly across departments, enabling businesses to make data-driven
          decisions.
        </p>
        <h2 className="wow fadeInDown" data-wow-delay="300ms">
          IT Consulting & System Integration
        </h2>
        <p className="wow fadeInDown" data-wow-delay="300ms">
          Our consultants help organizations adopt modern IT infrastructure and
          integrate new technologies with existing systems. We ensure smooth
          digital transitions without disrupting day-to-day operations.
        </p>
        {/* Flip Boxes */}
        <div className="row no-gutters ">
          {/* Box-1 */}
        <div className="row g-4"> {/* g-4 adds gap between all 3 cards */}
  {/* Box-1 */}
  <div className="col-lg-4 col-md-4 col-sm-12 wow fadeInLeft" data-wow-delay="400ms">
    <div
      className="blue-box h-100"
      style={{
        backgroundColor: "#002C5A",
        borderRadius: "12px",
        padding: "30px",
        textAlign: "center",
        color: "#FFFFFF",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
      }}
    >
      <FontAwesomeIcon
        icon={faCloud}
        size="2xl"
        style={{ marginTop: "40px", marginBottom: "15px", color: "#FFFFFF" }}
      />
      <h2 style={{ color: "#FFFFFF" }}>Industry-Specific Solutions</h2>
      <p style={{ fontWeight: "400", color: "#FFFFFF" }}>
        We’ve successfully delivered IT projects for defense services,
        air veterans, and pharmaceutical companies. Our tailored
        solutions address compliance requirements, improve transparency,
        and enhance operational efficiency.
      </p>
    </div>
  </div>

  {/* Box-2 */}
  <div className="col-lg-4 col-md-4 col-sm-12 wow fadeIn" data-wow-delay="300ms">
    <div
      className="blue-box h-100"
      style={{
        backgroundColor: "#002C5A",
        borderRadius: "12px",
        padding: "30px",
        textAlign: "center",
        color: "#FFFFFF",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
      }}
    >
      <FontAwesomeIcon
        icon={faDatabase}
        size="2xl"
        style={{ marginTop: "40px", marginBottom: "15px", color: "#FFFFFF" }}
      />
      <h2 style={{ color: "#FFFFFF" }}>Database Administration Services</h2>
      <p style={{ fontWeight: "400", color: "#FFFFFF" }}>
        Our database experts ensure your critical data is always secure,
        reliable, and available. Services include database design,
        performance tuning, backup and recovery solutions, and migration
        to cloud platforms.
      </p>
    </div>
  </div>

  {/* Box-3 */}
  <div className="col-lg-4 col-md-4 col-sm-12 wow fadeInRight" data-wow-delay="400ms">
    <div
      className="blue-box h-100"
      style={{
        backgroundColor: "#002C5A",
        borderRadius: "12px",
        padding: "30px",
        textAlign: "center",
        color: "#FFFFFF",
        // display: "flex",
        flexDirection: "column",
        justifyContent: "center"
      }}
    >
      <FaLaptop
        style={{ marginTop: "40px", marginBottom: "15px", fontSize: "35px", color: "#FFFFFF" }}
      />
      <h2 style={{ color: "#FFFFFF" }}>Customized Application Development</h2>
      <p style={{ fontWeight: "400", color: "#FFFFFF" }}>
        We design and develop applications tailored to your
        organization’s specific workflows. From web-based portals to
        mobile apps, our solutions are scalable, user-friendly, and
        optimized for performance.
      </p>
    </div>
  </div>
</div>

        </div>

        <div className="erp-section mt-5">
          <h2 className="text-center mb-4">
            Enterprise ERP Solutions for Manufacturing, Contracting & Retail
          </h2>
          <h3 className="text-center text-muted mb-3">
            Streamline Your Business with Expert ERP Enterprise Resource
            Planning Software
          </h3>

          <p className="text-center">
            Unlock the full potential of your enterprise with Access Infotech's
            off-the-shelf enterprise resource planning (ERP) system software.
          </p>

          <div className="row mt-4">
            {/* Card 1 */}
            <div className="col-md-6 col-lg-4 mb-4">
              <div className="card shadow-lg h-100 border-0 rounded-4">
                <div className="card-body">
                  <h4 className="card-title">What is ERP?</h4>
                  <p className="card-text">
                    ERP (Enterprise Resource Planning) is an integrated system
                    software that manages finance, supply chain, production, and
                    customer relations—all centralized for seamless operations.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 2 */}
            <div className="col-md-6 col-lg-4 mb-4 ">
              <div className="card shadow-lg h-100 border-0 rounded-4">
                <div className="card-body">
                  <h4 className="card-title">Why Choose Us?</h4>
                  <ul className="list-unstyled">
                    <li>
                      ✅ Comprehensive ERP modules for manufacturing & retail
                    </li>
                    <li>✅ Scalable and customizable solutions</li>
                    <li>✅ Proven expertise & strong support</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Card 3 */}
            <div className="col-md-6 col-lg-4 mb-4">
              <div className="card shadow-lg h-100 border-0 rounded-4">
                <div className="card-body">
                  <h4 className="card-title">Key Benefits</h4>
                  <ul className="list-unstyled">
                    <li>✅ Real-time production monitoring</li>
                    <li>✅ Inventory & supply chain optimization</li>
                    <li>✅ Data-driven decision support</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Modules Section in Cards */}
          <div className="modules-section mt-5">
            <h2 className="text-center">Modules Offered</h2>
            <div className="row mt-3">
              <div className="col-md-6">
                <div className="card shadow-sm  h-100 border-0 mb-3 rounded-4">
                  <div className="card-body">
                    <ul className="list-unstyled mb-0">
                      <li>📊 Accounting and Finance</li>
                      <li>🛒 Purchase</li>
                      <li>📦 Warehouse</li>
                      <li>💼 Sales</li>
                      <li>⚙️ Production Planning (PPC)</li>
                      <li>👨‍💼 Human Resource</li>
                      <li>🤝 CRM</li>
                      <li>📈 Business Intelligence</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card shadow-sm h-100 border-0 mb-3 rounded-4">
                  <div className="card-body">
                    <ul className="list-unstyled mb-0">
                      <li>🛠️ Machine Maintenance</li>
                      <li>🏢 Multi Company Accounting</li>
                      <li>🌍 Multi Site Management</li>
                      <li>📂 Project Management</li>
                      <li>📱 Mobility & Updates</li>
                      <li>💬 Collaboration Tools</li>
                      <li>🚀 Growth Focused Features</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Services;
